import {Component, Input} from '@angular/core';
import {MessageType} from '../../enums/message-type';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-display-message',
  imports: [
    TranslatePipe
  ],
  templateUrl: './display-message.component.html',
  styleUrl: './display-message.component.scss'
})
export class DisplayMessageComponent {
  @Input()
  public type: MessageType = MessageType.INFO;

  @Input()
  public message = '';
}
